import React from "react";

import { connect } from "react-redux";
import { Formik, Field } from "formik";
import FormControl from "@material-ui/core/FormControl";

import TextField from "../../components/CstmTextField";
import ScreenWrapper from "../../components/ScreenWrapper";
import MobileTextField from "../../components/MobileTextField";

import { PAGES } from "../../config/constants";

import validate from "./validations";

const BorrowerInfo2 = ({ setFormValue, forBorrower }) => {
  return (
    <ScreenWrapper step={4}>
      <Formik
        initialValues={forBorrower}
        onSubmit={(values) => {
          setFormValue(values);
        }}
        validate={validate}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            <Field
              name="first_name"
              label="First Name of Borrower"
              component={TextField}
              required
            />

            <Field
              name="last_name"
              label="Last Name of Borrower"
              component={TextField}
              required
              style={{ marginTop: 10 }}
            />

            <FormControl
              variant="outlined"
              style={{ marginTop: 15, width: "100%" }}
              id="mobile_formControl"
            >
              <Field
                name="phone_mobile"
                label="Mobile # of Borrower"
                component={MobileTextField}
                required
              />
            </FormControl>

            <Field
              name="email"
              label="Email of Borrower"
              component={TextField}
              style={{ marginTop: 10 }}
            />

            <div style={{ marginTop: 10 }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={handleSubmit}
                >
                  Next
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </Formik>
    </ScreenWrapper>
  );
};

const mapState = (state) => {
  return {
    contacts: state.form.contacts,
    showError: state.form.showError,
    forBorrower: state.form.forBorrower,
  };
};

const mapDispatch = (dispatch) => {
  return {
    setPrevPage: () => {
      dispatch({
        type: "SET_PAGE",
        payload: PAGES.BROKER_QUESTION,
      });
    },
    setFormValue: (values) => {
      dispatch({
        type: "SET_FOR_BORROWER",
        payload: {
          forBorrower: values,
        },
      });

      dispatch({
        type: "SET_PAGE",
        payload: PAGES.BORROWER_CREDIT,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(BorrowerInfo2);



// WEBPACK FOOTER //
// ./src/Screens/BorrowerInfo2/index.js